import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import api, { localized, fileUrl } from "@/lib/api";
import { ProducersMap } from "@/components/ProducersMap";

export default function Vendors() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const [vendors, setVendors] = useState([]);
  useEffect(() => { api.get("/vendors").then((r) => setVendors(r.data)).catch(() => {}); }, []);
  const withCoords = vendors.filter((v) => typeof v.lat === "number");

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="vendors-page">
      <p className="overline">{t("vendors.overline")}</p>
      <h1 className="font-serif text-5xl lg:text-6xl tracking-tight mt-2">{t("vendors.title")}</h1>
      <p className="text-ink-soft mt-4 max-w-2xl">{t("vendors.subtitle")}</p>

      <div className="mt-10" data-testid="vendors-map-wrapper">
        <ProducersMap vendors={vendors} height="520px" />
        <p className="text-xs text-ink-muted mt-2 italic">{t("counts.producers", { count: withCoords.length })} · {t("vendors.mapCaption").split("·")[1]?.trim()}</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-16" data-testid="vendors-grid">
        {vendors.map((v) => (
          <Link key={v.vendor_id} to={`/vendor/${v.vendor_id}`} className="group block bg-white hairline rounded-sm overflow-hidden hover:-translate-y-1 transition-all" data-testid={`vendor-row-${v.vendor_id}`}>
            <div className="aspect-[3/2] overflow-hidden">
              {v.cover_image && <img src={fileUrl(v.cover_image)} alt={localized(v, "farm_name", lang)} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />}
            </div>
            <div className="p-8">
              <p className="overline">{localized(v, "region", lang)}</p>
              <h2 className="font-serif text-3xl mt-2">{localized(v, "farm_name", lang)}</h2>
              <p className="text-ink-soft mt-3 line-clamp-3">{localized(v, "story", lang)}</p>
            </div>
          </Link>
        ))}
        {vendors.length === 0 && <p className="text-ink-muted">{t("vendors.noVendors")}</p>}
      </div>
    </div>
  );
}
